
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";
  import storage from "@/services/storage";


  @Component
  export default class ImageSample extends Vue {
    @Prop({type: String, default: undefined}) readonly fileName!: string;
    filePath: any = null;

    @Watch("fileName", { immediate: true })
    async getFile() {
      this.filePath = await storage.get(this.fileName);
    }
  }
